import AuthorCard from "@/components/AuthorCard";
import TagIcon from "@/components/TagIcon";
import { parseDate } from "@/helpers";
import { isFilled } from "@prismicio/client";
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";

export const BlogArticleCard = ({ article, isRow = false }) =>
  <PrismicNextLink field={article} className="">
    <div className={`flex flex-col ${isRow ? "lg:flex-row lg:gap-10 lg:items-center" : "flex-col"} gap-5 items-start`}>
      <PrismicNextImage
        field={article.data.preview_image}
        className={`object-cover ${isRow ? "w-full lg:w-[230px]" : "w-full"} h-[185px] rounded-[20px]`}
      />
      <div className="flex flex-col gap-3">
        <div className="flex flex-col items-start gap-2.5">
          <TagIcon tag={article.data.type} />
          <div className="flex flex-row items-center lg:items-center gap-2">
            <p className="p-sm-n lt text-bleu-90">{parseDate(article.data.preview_date)}</p>
            <img src="/icons/dot-separator.svg" alt="" width={3} height={3} aria-hidden />
            <h3 className="p-sm-n lt text-bleu-90 ">
              {article.data.preview_read_time} min de lecture
            </h3>
          </div>
        </div>

        <PrismicRichText
          field={article.data.preview_title}
          components={{
            heading1: ({ children }) => <h3 className="p-lg-n sbd text-bleu">{children}</h3>,
            heading2: ({ children }) => <h3 className="p-lg-n sbd text-bleu">{children}</h3>,
          }}
        />
        <AuthorCard author={article.data.preview_author} />
      </div>
    </div>
  </PrismicNextLink>

const BlogArticleCardLight = ({ article }) =>
  <PrismicNextLink field={article} className="flex-1">
    <div className="flex flex-col gap-4 items-start">
      <PrismicNextImage
        field={article.data.preview_image}
        className="object-cover w-full h-[185px] rounded-[20px]"
      />
      <div className="flex flex-col items-start gap-2">
      <TagIcon tag={article.data.type} />
      <PrismicRichText
        field={article.data.preview_title}
        components={{
          heading1: ({ children }) => (
            <h3 className="p-lg-n sbd text-bleu">{children}</h3>
          ),
          heading2: ({ children }) => (
            <h3 className="p-lg-n sbd text-bleu">{children}</h3>
          ),
        }}
      />
      </div>
      
    </div>
  </PrismicNextLink>



/**
 * @typedef {import("@prismicio/client").Content.BlogSliceArticlePrimary} ArticlePrimary
 * @param {{ primary: ArticlePrimary }} props
 */
const Article = ({ primary }) => (
  <div className="flex flex-col gap-5">
    {isFilled.richText(primary.title) && (
      <PrismicRichText
        field={primary.title}
        components={{
          heading2: ({ children }) => (
            <h2 className="h4-n font-medium text-bleu">{children}</h2>
          ),
        }}
      />
    )}
    <div className="flex flex-col lg:flex-row gap-10 lg:gap-6">
      {primary.articles.map(({ article }, index, arr) => {
        if (arr.length === 1) {
          return (
            <BlogArticleCard key={index} article={article} isRow={true} />
          );
        }
        if (arr.length === 2) {
          return (
            <BlogArticleCardLight key={index} article={article} />
          );
        }
        return null;
      })}
    </div>
  </div>
);

export default Article;
